import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Do you offer windshield replacement near me?',
    a: "Kosin's Glass serves Howell, Ann Arbor, Novi and many surrounding Southeast Michigan communities. Request a quote and the team will confirm availability for your vehicle and location."
  }, {
    q: "Can Kosin's Glass help with my insurance claim?",
    a: "Yes. Kosin's Glass works with most insurance companies and can help you with quote details, claim coordination and scheduling."
  }, {
    q: 'Do I need ADAS calibration after windshield replacement?',
    a: "If your vehicle has a forward-facing camera or sensor mounted near the windshield, calibration may be required after replacement. Kosin's Glass offers on-site ADAS recalibration."
  }, {
    q: 'Can a windshield chip be repaired instead of replaced?',
    a: "Some small chips may be repairable, especially if they are away from the driver's direct line of sight and away from the windshield edge. Cracks and spreading damage usually require replacement."
  }, {
    q: 'Do you replace side windows, door glass and rear windows?',
    a: "Yes. Kosin's Glass replaces side windows, driver and passenger door glass, quarter glass, rear windows, truck rear glass, moon roof glass, sun roof glass and T-top glass."
  }, {
    q: 'Is same-day auto glass service available?',
    a: 'Same-day openings may be available depending on the vehicle, glass availability and schedule. Request a quote or call the Howell Auto Glass Service Center to check availability.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 lg:py-24 bg-white" data-id="element-29">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="text-center mb-12" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-32">
            Auto Glass Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-33">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-brand-blue shadow-md shadow-brand-blue/5' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-34">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white focus:outline-none" aria-expanded={isOpen} data-id="element-35">
                  <span className="text-lg font-bold text-navy-900 pr-8" data-id="element-36">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brand-blue' : ''}`} data-id="element-37" />
                </button>
                <AnimatePresence initial={false} data-id="element-38">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-39">
                      <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-40">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}